import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-3" }
const _hoisted_3 = { class: "field col-12 lg:col-2 lg:col-offset-7 text-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_5 = {
  key: 0,
  class: "col-12"
}
const _hoisted_6 = {
  key: 1,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statInvoiceByYear.year")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.year,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
          options: _ctx.years,
          onChange: _ctx.dataChanged,
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "code",
              sortOrder: 1,
              style: {"font-size":"smaller"},
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "company",
                  header: _ctx.t('statInvoiceByYear.company'),
                  headerStyle: "width: 15.5%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? data[field].name : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthDates, (monthDate) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    field: "invoices",
                    header: _ctx.FormatHelpers.capitalizeFirstLetter(_ctx.d(monthDate, 'shortMonthOnly')),
                    headerStyle: "width: 6.5%",
                    bodyClass: "text-right",
                    key: monthDate.toTimeString()
                  }, {
                    body: _withCtx(({ data, field }) => [
                      _createTextVNode(_toDisplayString(_ctx.renderInvoiceValue(data[field], monthDate)), 1)
                    ]),
                    _: 2
                  }, 1032, ["header"]))
                }), 128)),
                _createVNode(_component_Column, {
                  field: "total",
                  header: _ctx.t('statInvoiceByYear.total'),
                  headerStyle: "width: 6.5%",
                  bodyClass: "text-right"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(_ctx.n(data[field], "currencyEUR") ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}